import { Request } from 'effect';
export class GetForSpace extends Request.TaggedClass('@fixtuur/GavelTemplatesService/GetForSpace') {
}
export class GetById extends Request.TaggedClass('@fixtuur/GavelTemplatesService/GetById') {
}
